var hasWindow = function hasWindow() {
  return typeof window === "object" && !!window.document;
};

export default hasWindow;